import React from "react";
import * as styles from "/src/components/FormModal.module.css";
import { ImCancelCircle } from "@react-icons/all-files/im/ImCancelCircle";
import { useState } from "react";
import { send } from "emailjs-com";

const FormModal = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const [completeMsg, setCompleteMsg] = useState(false);
  const [values, setValues] = useState({
    name: "",
    email: "",
    school: "",
  });

  const inputs = [
    {
      id: 1,
      name: "name",
      type: "text",
      errorMessage: "Please enter a valid name!",
      label: "Name",
      required: true,
    },
    {
      id: 2,
      name: "email",
      type: "email",
      errorMessage: "Please enter a valid email address!",
      label: "Email",
      required: true,
    },
    {
      id: 3,
      name: "school",
      type: "text",
      errorMessage: "",
      label: "School (optional)",
      required: false,
    },
  ];

  var templateParams = {
    name: values.name,
    email: values.email,
    school: values.school,
    project: props.name,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setShowSpinner(true);
    await send(
      process.env.GATSBY_EMAILJS_SERVICE_ID,
      process.env.GATSBY_EMAILJS_FORM_TEMPLATE_ID,
      templateParams,
      process.env.GATSBY_EMAILJS_USER_ID
    )
      .then((response) => {
        setTimeout(async () => {
          await setShowSpinner(false);
          await setCompleteMsg(true);
        }, 1000);
      })
      .catch((err) => {
        console.warn("FAILED...", err);
        alert("Sorry something went wrong! Please try again later.");
      });
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <div className={styles.modalOverlay}></div>
      <div className={styles.modal}>
        <ImCancelCircle
          className={styles.modalCloseButton}
          onClick={props.cancel}
          size={20}
        />
        {completeMsg ? (
          <div>
            Thank you for signing up! We have received your details and will
            contact you shortly.
          </div>
        ) : (
          <>
            <h1>Thank you for volunteering!</h1>
            <h4>You have expressed interest for {props.name}.</h4>
            <div className={styles.formContainer}>
              <form onSubmit={handleSubmit}>
                {inputs.map((input) => (
                  <FormInput
                    key={input.id}
                    {...input}
                    value={values[input.name]}
                    onChange={onChange}
                  />
                ))}

                <div className={styles.buttonContainer}>
                  <button>
                    <div>Submit</div>
                    {showSpinner && <SpinnerModal />}
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const SpinnerModal = () => {
  return (
    <div className={styles.spinnerModal}>
      <div className={styles.spinner} />
    </div>
  );
};

const FormInput = (props) => {
  const [focused, setFocused] = useState(false);
  const { label, errorMessage, onChange, id, ...inputProps } = props;

  const handleFocus = (e) => {
    setFocused(true);
  };

  return (
    <div className={styles.formInput}>
      <label>
        <h5>{label}</h5>
      </label>
      <input
        {...inputProps}
        onChange={onChange}
        onBlur={handleFocus}
        onFocus={() =>
          inputProps.name === "confirmPassword" && setFocused(true)
        }
        focused={focused.toString()}
      />
      <span>{errorMessage}</span>
    </div>
  );
};

export default FormModal;
